import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-general',
	templateUrl: './general.component.html',
	standalone: false,
})
export class StatementOfAccountGeneralComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
